import { Component, OnChanges } from '@angular/core';

import { BaseGridComponent } from '../../base-grid/base-grid.component';
import { CostCenterConfigurationService } from 'src/shared/services/cost-center-configuration.service';
import { JobCell } from '../../models/job-cell.model';
import { JobRatioCell } from '../../models/job-ratio-cell.model';
import { JobTitle } from 'src/shared/models/job-title.model';
import { MiscUtil } from 'src/shared/utilities/misc.util';
import { StaffRatioValue } from 'src/shared/models/staff-ratio-value.model';

@Component({
  selector: 'smt-variable-job-uos-grid',
  templateUrl: './variable-job-uos-grid.component.html',
  styleUrls: ['./variable-job-uos-grid.component.scss']
})
export class VariableJobUosGridComponent extends BaseGridComponent implements OnChanges {
    jobTitles: JobTitle[];
    staffingGrid: JobRatioCell[][] = [];

    constructor(private _costCenterConfigurationService: CostCenterConfigurationService) { 
        super(_costCenterConfigurationService);

        super.initializeGridProcess(() => this.buildRatioGrid(), () => this.initializeRatios());
    }

    ngOnChanges() {
        this.jobTitles = this.costCenter.variableJobTitles;

        super.Process();
    }   

    private buildJobCell(id: string, columnId: string, jobTitleId: number, value: number): JobCell {
        let jobCell = new JobCell();

        jobCell.columnId = columnId;
        jobCell.id = id;
        jobCell.jobTitleId = jobTitleId;
        jobCell.rowId = "0";
        jobCell.value = value;
        
        return jobCell;
    }

    buildRatioGrid() : JobCell[][] {
        this.staffingGrid = [];
        
        let ratioGrid: JobCell[][]= [];
        let ratioRow: JobCell[] = [];
        let staffingGridRow: JobRatioCell[] = [];
        let columnId = "0";
        
        this.jobTitles.forEach(j => {            
            let staffValue: number;
            let uosCount: number;

            let ratioValue = this.findRatioByJobTitleId(j.id);

            if (ratioValue) {
                staffValue = ratioValue.staffValue;
                uosCount = ratioValue.uosCount;
            }
            else {
                staffValue = null;
                uosCount = null;
            }
            
            let denominator = this.buildJobCell('denominator-' + j.id, columnId, j.id, uosCount);
            let numerator = this.buildJobCell('numerator-' + j.id, columnId, j.id, staffValue);
    
            ratioRow.push(numerator);
            ratioRow.push(denominator);

            let cell = new JobRatioCell();
            
            cell.denominator = denominator;
            cell.numerator = numerator;

            staffingGridRow.push(cell);
        });

        ratioGrid.push(ratioRow);
        this.staffingGrid.push(staffingGridRow);

        return ratioGrid;
    }

    buildRatioValues() : StaffRatioValue[] {
        let ratios = [];

        this.jobTitles.forEach(j => {
            let ratio = this.findRatioByJobTitleId(j.id);
    
            if (!ratio) {
                ratio = new StaffRatioValue();

                ratio.jobTitleId = j.id;
                ratio.shiftScheduleId = this.shiftSchedule.id;  
                ratio.staffValue = null;
                ratio.uosCount = null;              
            }
    
            ratios.push(ratio);
          });
    
        return ratios;
    }

    private findRatioByJobTitleId(jobTitleId: number): StaffRatioValue {
        if (!this.shiftSchedule || !this.shiftSchedule.staffRatios) {
            return null;
        }

        return this.shiftSchedule.staffRatios.find(r => !r.inactiveDate && r.jobTitleId === jobTitleId); 
    }

    private initializeRatios() {
        this.shiftSchedule.staffRatios = this.buildRatioValues();
    }

    updateShiftCell(cell: JobCell) {
        let ratio = this.findRatioByJobTitleId(cell.jobTitleId);

        if (!ratio) {
            ratio = new StaffRatioValue();
        }

        ratio.jobTitleId = cell.jobTitleId;

        if (MiscUtil.isValidNumber(cell.value)) {
            ratio.staffValue = cell.value;
        } 
        else {
            ratio.staffValue = null;
        }
    }

    updateUosCell(cell: JobCell) {
        let ratio = this.findRatioByJobTitleId(cell.jobTitleId);

        if (!ratio) {
            ratio = new StaffRatioValue();            
        }

        ratio.jobTitleId = cell.jobTitleId;

        if (MiscUtil.isValidNumber(cell.value)) {
            ratio.uosCount = cell.value;
        } 
        else {
            ratio.uosCount = null;
        }
    };
    
}
